module.exports = __webpack_public_path__ + "static/media/Pressemitteilungen.cf4c75c5.png";